// ProductCard.js

import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { CartContext } from '../contexts/CartContext';
import './ProductCard.css';

const ProductCard = ({ product }) => {
    // Determinar el primer archivo de media, ya sea imagen o video
    const [currentIndex, setCurrentIndex] = useState(0);
    const isVideo = product.media && product.media[currentIndex]?.endsWith('.mp4');

    // Determinar la clase de estado del producto
    let productStatusClass = '';
    if (product.stock === 0) {
        productStatusClass = 'out-of-stock';
    } else if (product.stock < 5) {
        productStatusClass = 'low-stock';
    } else if (product.averageRating >= 4) {
        productStatusClass = 'popular';
    }

    // Obtener la función addToCart desde el contexto del carrito
    const { addToCart } = useContext(CartContext);

    // Estado local para la cantidad
    const [quantity, setQuantity] = useState(1);

    // Función para manejar el cambio de cantidad
    const handleQuantityChange = (e) => {
        const value = Math.max(1, Math.min(parseInt(e.target.value), product.stock));
        setQuantity(value);
    };

    // Navegación en medios
    const nextMedia = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % product.media.length);
    };

    const prevMedia = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + product.media.length) % product.media.length);
    };

    // Formatear el precio para mostrarlo en euros
    const formattedPrice = new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR'
    }).format(product.price);

    return (
        <div className={`product-card ${productStatusClass}`}>
            <Link to={`/product/${product._id}`} className="product-link">
                <div className="media-container">
                    {isVideo ? (
                        <video
                            src={product.media[currentIndex]}
                            className="product-media"
                            autoPlay={currentIndex === 0}
                            controls={currentIndex !== 0}
                            loop
                            muted
                        />
                    ) : (
                        <img
                            src={product.media[currentIndex]}
                            alt={product.name}
                            className="product-image"
                        />
                    )}
               
                </div>
                <h2 className="product-title">{product.name}</h2>
                <p className="product-description">{product.description}</p>
            </Link>
            <p className="product-price">Precio: {formattedPrice}</p>
            <p className="product-stock">Stock: {product.stock}</p>
            {/* Mostrar calificación promedio si está disponible */}
            {product.averageRating > 0 && (
                <p className="product-rating">Calificación: {product.averageRating.toFixed(1)} / 5</p>
            )}
            {/* Selector de cantidad */}
            {product.stock > 0 && (
                <div className="quantity-selector">
                    <label htmlFor={`quantity-${product._id}`}>Cantidad:</label>
                    <input
                        type="number"
                        id={`quantity-${product._id}`}
                        min="1"
                        max={product.stock}
                        value={quantity}
                        onChange={handleQuantityChange}
                    />
                </div>
            )}
            {/* Botón de agregar al carrito */}
            <button
                className="add-to-cart-button"
                onClick={() => addToCart(product, quantity)}
                disabled={product.stock === 0}
            >
                {product.stock === 0 ? 'Agotado' : 'Agregar al Carrito'}
            </button>
        </div>
    );
};

export default ProductCard;
